export default __webpack_public_path__ + "static/media/bruno-abatti.62de0ac8.jpg";